export const keys = {
  tab: "Tab",
  escape: "Escape",
  enter: "Enter",
  left: "ArrowLeft",
  right: "ArrowRight",
  home: "Home",
  end: "End",
  space: " "
};
